export function shouldApplyCustomSubmitFollowUp(result) {
  return result?.handled !== true;
}
